import { render, staticRenderFns } from "./RTHeader.vue?vue&type=template&id=634d433f&scoped=true&"
import script from "./RTHeader.vue?vue&type=script&lang=js&"
export * from "./RTHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d433f",
  null
  
)

export default component.exports